"use client";

import { debounce } from "@/utils";
import { useEffect } from "react";


export const useWindowResizeObserver = (props: any) => {
    const { callback } = props;
    const fn = debounce(()=> {
        callback({innerHeight: window.innerHeight, innerWidth: window.innerWidth})
    }, 100)
    useEffect(() => {
        window.addEventListener('resize', fn)
        return () => {
            window.removeEventListener('resize', fn)
        };
    }, []);
    return null;
};
